import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiRequest from '../../api/request';
import { formatDataForDataTable } from '../../utils/formatData';

const initialState = {
  data: [],
  loading: false,
  error: '',
  analytics: [],
  applications: [],
  singleApplication: {},
  leaveBypassCounts: [],
  empCompData: [],
  rhCompWorkReq: [],
  availableCompData: [],
  availableLeaveCredits: [],
  wfhTasks: [],
  requests: {},
  hrapplications: {},
  regularize: {},
  leaveAnalytics: {},
  meta: {},
};

export const getLeaveTypes = createAsyncThunk('leave/getLeaveTypes', async () => {
  const res = await apiRequest({
    method: 'get',
    url: 'leave/getLeaveTypes',
  });
  return res;
});

export const getLeaveAnalytics = createAsyncThunk('leave/getAnalytics', async (e) => {
  const res = await apiRequest({
    method: 'get',
    url: `analytics/leaveAnalytics/${e}`,
  });
  return res;
});
export const applyLeave = createAsyncThunk('leave/apply', async (e) => {
  const res = await apiRequest({
    url: 'leave/apply',
    method: 'post',
    data: e,
  });
  return res;
});

export const getLeaveAplictions = createAsyncThunk('leave/getApplications', async (year) => {
  const res = await apiRequest({
    url: `leave/getLeaveApplications/${year}`,
    method: 'get',
  });
  return res;
});

export const getLeaveAplictionsforReportingHead = createAsyncThunk('leave/getApplications_Rph', async (filter) => {
  const res = await apiRequest({
    url: `leave/getReportingHeadLeaveApplications/${filter}`,
    method: 'get',
  });
  // console.log(res);

  return res;
});

export const getLeaveAplictionsforHr = createAsyncThunk('leave/get_applications_hr', async (str) => {
  const res = await apiRequest({
    url: `leave/getAllLeaveApplications/${str}`,
    method: 'get',
  });

  return res;
});

export const getLeaveApplicationById = createAsyncThunk('leave/leave_apltn_by_id', async (id) => {
  const res = await apiRequest({
    method: 'get',
    url: `leave/getLeaveApplication/${id}`,
  });
  return res;
});

export const editLeave = createAsyncThunk('leave/edit', async (values) => {
  const res = await apiRequest({
    url: 'leave/editLeaveApplication',
    method: 'put',
    data: values,
  });
  return res;
});

export const deleteLeave = createAsyncThunk('leave/delete', async (id) => {
  const res = await apiRequest({
    method: 'delete',
    url: `leave/deleteLeaveApplication/${id}`,
  });
  return res;
});

export const getBypassCount = createAsyncThunk('leave/bypassCount', async (date) => {
  const res = await apiRequest({
    method: 'get',
    url: `analytics/leaveBypassCounts/${date}`,
  });
  return res;
});

export const approveLeaveReportingHead = createAsyncThunk('leave/approve_leave_hod', async (data) => {
  const res = await apiRequest({
    url: 'leave/reportingHeadApproval',
    method: 'post',
    data: data,
  });

  return res;
});

export const approveLeaveHr = createAsyncThunk('leave/approve_leave_Hr', async (data) => {
  const res = await apiRequest({
    url: 'leave/HRApproval',
    method: 'post',
    data: data,
  });

  return res;
});

export const getCompWorkReq = createAsyncThunk('leave/getCompWorkReq', async (data) => {
  const res = await apiRequest({
    url: `leave/compLeave?page=${data.page}&limit=${data.limit}&search=${
      data.search ? encodeURIComponent(data.search) : ''
    }`,
    method: 'get',
  });

  return res;
});
export const deleteComWorkreq = createAsyncThunk('leave/deleteComWorkreq', async (id) => {
  const res = await apiRequest({
    url: `leave/compLeave/${id}`,
    method: 'delete',
  });

  return res;
});
export const applyCompWorkReq = createAsyncThunk('leave/applyCompWorkReq', async (data) => {
  const res = await apiRequest({
    url: `leave/compLeave`,
    method: 'post',
    data: data,
  });

  return res;
});
export const updateCompWork = createAsyncThunk('leave/updateCompWork', async (data) => {
  const res = await apiRequest({
    url: `leave/compLeave/${data.id}`,
    method: 'patch',
    data: data,
  });

  return res;
});

export const getReportingHeadCompWorkReq = createAsyncThunk('leave/getReportingHeadCompWorkReq', async (data) => {
  const res = await apiRequest({
    url: `leave/compLeave/approve?page=${data.page}&limit=${data.limit}&search=${
      data.search ? encodeURIComponent(data.search) : ''
    }`,
    method: 'get',
  });

  return res;
});
export const approveActions = createAsyncThunk('leave/approveActions', async (data) => {
  const res = await apiRequest({
    url: `leave/compLeave/approve/${data.id}`,
    method: 'patch',
    data: data,
  });

  return res;
});
export const getAvailableCompLeave = createAsyncThunk('leave/getAvailableCompLeave', async () => {
  const res = await apiRequest({
    url: `leave/compLeave/available`,
    method: 'get',
  });

  return res;
});

export const getAvailableLeaveCredits = createAsyncThunk('leave/getAvailableLeaveCredits', async (data) => {
  const res = await apiRequest({
    url: `leave/getLeaveCount`,
    method: 'post',
    data: data,
  });

  return res;
});

export const getWorkFromHomeTasks = createAsyncThunk('leave/getWorkFromHomeTasks', async ({ leaveAppId, isHead }) => {
  const res = await apiRequest({
    url: `wfh-tasks?leaveapp_id=${leaveAppId}&isHead=${isHead ? true : false}`,
    method: 'get',
  });
  // console.log(res);

  return res;
});

export const taskApproveOrReject = createAsyncThunk('leave/taskApproveOrReject', async ({ value, leaveId }) => {
  const res = await apiRequest({
    url: `/wfh-tasks/change-wfh-status/${leaveId}`,
    method: 'put',
    data: { status: value },
  });

  return res;
});

export const reportingHeadTaskUpdate = createAsyncThunk('leave/reportingHeadTaskUpdate', async ({ data, leaveId }) => {
  const res = await apiRequest({
    url: `/wfh-tasks/${leaveId}`,
    method: 'post',
    data: data,
  });

  return res;
});

export const updateWFHTaskStatus = createAsyncThunk('leave/updateWFHTaskStatus', async (data) => {
  const res = await apiRequest({
    url: `wfh-tasks/${data.wfhtaskID}`,
    method: 'put',
    data: data,
  });

  return res;
});

export const requestleaveGrant = createAsyncThunk('leave/requestleaveGrant', async (data) => {
  const res = await apiRequest({
    url: `leave-grant-request`,
    method: 'post',
    data: data,
  });

  return res;
});
//-------------------------------------Attendance-regularaize ------------------------------------------------
export const RegularizationPostThunk = createAsyncThunk('leave/RegularizationPostThunk', async (data) => {
  const res = await apiRequest({
    url: `regularize/request`,
    method: 'post',
    data: data,
  });

  return res;
});

export const RegularizationGetThunk = createAsyncThunk(
  'leave/RegularizationGetThunk',
  async ({ view = '', page = '', limit = '', search = '', fromDate = '', toDate = '' }) => {
    const obj = {
      view,
      page: page,
      limit: limit,
      search: search,
      fromDate: fromDate,
      toDate: toDate,
    };
    const paramQuery = new URLSearchParams(obj);

    const res = await apiRequest({
      url: `regularize?${paramQuery.toString()}`,
      method: 'get',
    });

    return res;
  }
);

export const RegularizeActionThunk = createAsyncThunk(
  'leave/RegularizeActionThunk',
  async ({ ids, status, view = '' }) => {
    const res = await apiRequest({
      url: `regularize?view=${view}`,
      method: 'patch',
      data: { ids, status },
    });

    return res;
  }
);

export const RegularizeDeleteThunk = createAsyncThunk('leave/RegularizeDeleteThunk', async (id) => {
  const res = await apiRequest({
    url: `regularize/${id}`,
    method: 'delete',
  });

  return res;
});
//-------------------------------------------------------------------------------------
export const reportUpload = createAsyncThunk('leave/reportUpload', async (formData) => {
  const res = await apiRequest({
    method: 'post',
    url: `general/upload`,
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return res;
});

export const getLeaveGrantRequests = createAsyncThunk('leave/getLeaveGrantRequests', async (data) => {
  const res = await apiRequest({
    url: `leave-grant-request?page=${data.page}&limit=${data.limit}&search=${data.search}`,
    method: 'get',
  });

  return res;
});

export const hodApproveOrRejectGrant = createAsyncThunk('leave/hodApproveOrRejectGrant', async (data) => {
  const res = await apiRequest({
    url: `leave-grant-request/update-hod-status/${data.leaveId}`,
    method: 'put',
    data: data,
  });

  return res;
});

export const hrApprovalForLeaveGrant = createAsyncThunk('leave/hrApprovalForLeaveGrant', async (data) => {
  const res = await apiRequest({
    url: `leave-grant-request/update-hr-status/${data.leaveId}`,
    method: 'put',
    data: data,
  });

  return res;
});

export const deleteLeaveGrantApplication = createAsyncThunk('leave/deleteLeaveGrantApplication', async (leaveID) => {
  const res = await apiRequest({
    url: `leave-grant-request/${leaveID}`,
    method: 'delete',
  });

  return res;
});

export const updateLeaveGrantReq = createAsyncThunk('leave/updateLeaveGrantReq', async (data) => {
  const res = await apiRequest({
    url: `leave-grant-request/${data.leaveID}`,
    method: 'put',
    data: data,
  });

  return res;
});

export const getHrLeaveGrantApplications = createAsyncThunk('leave/getHrLeaveGrantApplications', async (data) => {
  const res = await apiRequest({
    url: `leave-grant-request/get-data-for-hr?page=${data.page}&limit=${data.limit}&search=${data.search}`,
    method: 'get',
  });

  return res;
});

//---------------------------------- Leave Anlytics ---------------------------------------
export const getLeaveAnalyticsWithCounts = createAsyncThunk(
  'leave/getLeaveAnalyticsWithCounts',
  async ({ startDate = '', endDate = '', status = '', department = '', page = 1, limit = 10, search = '' }) => {
    const searchParams = new URLSearchParams({
      startDate: startDate,
      endDate: endDate,
      hrApprovalStatus: status,
      deptId: department || '',
      page: page,
      limit: limit,
      search: search,
    });
    const res = await apiRequest({
      url: `analytics/leaveAnalyticsNew?${searchParams.toString()}`,
      method: 'get',
    });

    return res;
  }
);

const leaveSlice = createSlice({
  name: 'leave',
  initialState,
  reducers: {
    clearApplications: (state, action) => {
      return {
        ...state,
        applications: [],
      };
    },
    clearAllLeaveData: (state) => {
      state = initialState;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getLeaveTypes.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getLeaveTypes.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload.data;
    });
    builder.addCase(getLeaveTypes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });

    // leave analytics

    builder.addCase(getLeaveAnalytics.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getLeaveAnalytics.fulfilled, (state, action) => {
      return {
        ...state,
        analytics: action.payload.data.analytics,
        loading: false,
      };
    });

    // apply leave

    builder.addCase(applyLeave.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(applyLeave.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });

    // get leave applications

    builder.addCase(getLeaveAplictions.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getLeaveAplictions.fulfilled, (state, action) => {
      const applications = formatDataForDataTable(action.payload.data);
      return {
        ...state,
        applications: applications,
        loading: false,
      };
    });

    // getLeaveApplicationBy id

    builder.addCase(getLeaveApplicationById.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(getLeaveApplicationById.fulfilled, (state, action) => {
      return {
        ...state,
        singleApplication: action.payload.data,
        loading: false,
      };
    });

    // get leave applications for reporting head

    builder.addCase(getLeaveAplictionsforReportingHead.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getLeaveAplictionsforReportingHead.fulfilled, (state, action) => {
      const applications = formatDataForDataTable(action.payload.data.leaveTypes);
      return {
        ...state,
        applications: applications,
        loading: false,
      };
    });
    // leave applications for hr
    builder.addCase(getLeaveAplictionsforHr.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getLeaveAplictionsforHr.fulfilled, (state, action) => {
      const applications = formatDataForDataTable(action.payload.data.leaveTypes);
      return {
        ...state,
        applications: applications,
        loading: false,
      };
    });

    // delete leave

    builder.addCase(deleteLeave.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(deleteLeave.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    //bypassCount
    builder.addCase(getBypassCount.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(getBypassCount.fulfilled, (state, action) => {
      const leaveBypassCounts = formatDataForDataTable(action.payload.data.leaveBypassCounts);
      return {
        ...state,
        leaveBypassCounts: leaveBypassCounts,
        loading: false,
      };
    });
    // -----------------------getCompWorkReq----------------------
    builder.addCase(getCompWorkReq.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(getCompWorkReq.fulfilled, (state, action) => {
      const data = action.payload;
      return {
        ...state,
        empCompData: data,

        loading: false,
      };
    });
    // -----------------applyCompWorkReq--------------------------------
    builder.addCase(applyCompWorkReq.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(applyCompWorkReq.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // -----------------deleteComWorkreq----------------------------
    builder.addCase(deleteComWorkreq.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(deleteComWorkreq.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ----------------updateCompWork----------------------------
    builder.addCase(updateCompWork.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(updateCompWork.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ----------------getReportingHeadCompWorkReq-------------------------------
    builder.addCase(getReportingHeadCompWorkReq.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(getReportingHeadCompWorkReq.fulfilled, (state, action) => {
      const data = action.payload;
      return {
        ...state,
        rhCompWorkReq: data,
        loading: false,
      };
    });
    // --------------approveActions--------------------------------
    builder.addCase(approveActions.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(approveActions.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ------------getAvailableCompLeave--------------------------
    builder.addCase(getAvailableCompLeave.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(getAvailableCompLeave.fulfilled, (state, action) => {
      return {
        ...state,
        availableCompData: formatDataForDataTable(action.payload.data),
        loading: false,
      };
    });
    // -----------------getAvailableLeaveCredits----------------------------
    builder.addCase(getAvailableLeaveCredits.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(getAvailableLeaveCredits.fulfilled, (state, action) => {
      return {
        ...state,
        availableLeaveCredits: action.payload.data,
        loading: false,
      };
    });
    // ------------------------------ GET WFH TASKS ---------------------------------
    builder.addCase(getWorkFromHomeTasks.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(getWorkFromHomeTasks.fulfilled, (state, action) => {
      return {
        ...state,
        wfhTasks: action.payload?.data,
        loading: false,
      };
    });
    // ------------------------------ UPDATE WFH TASK STATUS ---------------------------------
    builder.addCase(updateWFHTaskStatus.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(updateWFHTaskStatus.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ------------------------------ REQUEST LEAVE GRANT ---------------------------------
    builder.addCase(requestleaveGrant.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(requestleaveGrant.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ------------------------------ REPORT UPLOAD ---------------------------------
    builder.addCase(reportUpload.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(reportUpload.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ------------------------------ APPORVE OR REJECT THE TASK ---------------------------------
    builder.addCase(taskApproveOrReject.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(taskApproveOrReject.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ------------------------------ REPORTING HEAD TASK UPDATE ---------------------------------
    builder.addCase(reportingHeadTaskUpdate.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(reportingHeadTaskUpdate.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ------------------------------ GET LEAVE GRANT REQUESTS ---------------------------------
    builder.addCase(getLeaveGrantRequests.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(getLeaveGrantRequests.fulfilled, (state, action) => {
      return {
        ...state,
        requests: action.payload,
        loading: false,
      };
    });
    // ------------------------------ HOD APPROVE OR REJECT LEAVE GRANT REQUESTS ---------------------------------
    builder.addCase(hodApproveOrRejectGrant.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(hodApproveOrRejectGrant.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ------------------------------ DELETE LEAVE GRANT APPLICATION ---------------------------------
    builder.addCase(deleteLeaveGrantApplication.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(deleteLeaveGrantApplication.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ------------------------------ UPDATE LEAVE GRANT APPLICATION ---------------------------------
    builder.addCase(updateLeaveGrantReq.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(updateLeaveGrantReq.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ------------------------------------- GET LGR FOR HR ----------------------------------------------
    builder.addCase(getHrLeaveGrantApplications.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(getHrLeaveGrantApplications.fulfilled, (state, action) => {
      return {
        ...state,
        hrapplications: action.payload,
        loading: false,
      };
    });
    // ---------------------------------- HR STATUS --------------------------------
    builder.addCase(hrApprovalForLeaveGrant.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(hrApprovalForLeaveGrant.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });

    // ---------------------------------- Regularization --------------------------------
    //                        -------Post-----

    builder.addCase(RegularizationPostThunk.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(RegularizationPostThunk.fulfilled, (state) => {
      state.loading = false;
    });
    //                        -------Get-----
    builder.addCase(RegularizationGetThunk.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(RegularizationGetThunk.fulfilled, (state, action) => {
      state.loading = false;
      state.regularize = {
        data: action.payload.data,
        meta: action.payload.meta,
      };
    });

    //                        -------Put-----
    builder.addCase(RegularizeActionThunk.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(RegularizeActionThunk.fulfilled, (state) => {
      state.loading = false;
    });
    //                        -------Delete-----
    builder.addCase(RegularizeDeleteThunk.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(RegularizeDeleteThunk.fulfilled, (state) => {
      state.loading = false;
    });

    //----------------------------------- Leave Analytics --------------------------
    builder.addCase(getLeaveAnalyticsWithCounts.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getLeaveAnalyticsWithCounts.fulfilled, (state, action) => {
      state.loading = false;
      state.leaveAnalytics = action.payload.data;
      state.meta = action.payload.meta;
    });
  },
});
export const { clearAllLeaveData, clearApplications } = leaveSlice.actions;
export default leaveSlice.reducer;
